import React from "react";

const RightArrow  = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M20.445 18L8 5.555 11.555 2l16 16-16 16L8 30.445 20.445 18z"
          fill={fill}
      />
    </svg>
);

export default RightArrow;
